import { render, staticRenderFns } from "./MovementHistoryView.vue?vue&type=template&id=3a67abfe"
import script from "./MovementHistoryView.vue?vue&type=script&lang=js"
export * from "./MovementHistoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports